import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Header from "./components/Header";
import Footer from "./components/Footer";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Header />
      <main className="pt-20">
        <AppRoutes />
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
